import { getLocationAccessPoints } from '../../api/access-points';
import { AccessPointReadDTO, ActivityNimUpdateDTO } from '../../api/dto';
import { FilterTypeEnum } from '../../components/searching/filters';
import { fetchAccessPointsByName } from '../../lib/api';
import { FetchUseCase } from '../fields/AsyncAutocompleteElement';
import { AsyncAutocompleteFormElement, TFilterElement, TFormElement } from '../types';
import { UiSchemaType } from '../UiSchemaType';

const accessPointTypeProperties = (): AsyncAutocompleteFormElement['typeProperties'] => ({
    idField: 'accessPointName',
    fetchOptions: (searchTerm) => fetchAccessPointsByName(searchTerm),
    fetchUseCases: [FetchUseCase.ON_KEYSTROKE],
    getOptionLabel: (value) => value.name,
    multiple: false,
});
interface AccessPointFilterSchemaParameters extends Pick<TFilterElement, 'id' | 'label'> {}

export const accessPointFilterSchema = ({ id, label }: AccessPointFilterSchemaParameters): TFilterElement => ({
    type: FilterTypeEnum.AUTOCOMPLETE_ASYNC_CONTAINS,
    id,
    label,
    valueGetter: (value: AccessPointReadDTO | string) => (typeof value === 'string' ? value : value?.name),
    typeProperties: {
        ...accessPointTypeProperties(),
        autocompleteProps: {
            openOnFocus: true,
            disableCloseOnSelect: false,
        },
    },
});

const locationAccessPointTypeProperties = (): AsyncAutocompleteFormElement['typeProperties'] => ({
    idField: 'id',
    fetchOptions: async (searchTerm, exactId, idField, values) =>
        getLocationAccessPoints({
            facilityCode: (values?.[0] as ActivityNimUpdateDTO['facility'] | null | undefined)?.code ?? null,
        }),
    watchPaths: (path: string) => ['facility'],
    fetchUseCases: [FetchUseCase.ON_OPEN],
    getOptionLabel: (value: AccessPointReadDTO) => value.name,
    multiple: true,
});
interface LocationAccessPointSchemaParameters
    extends Pick<AsyncAutocompleteFormElement, 'path' | 'label' | 'required'> {}

export const locationAccessPointSchema = ({
    path,
    label,
    required,
}: LocationAccessPointSchemaParameters): TFormElement => ({
    type: UiSchemaType.AUTOCOMPLETE_ASYNC,
    path,
    label,
    required,
    typeProperties: locationAccessPointTypeProperties(),
});
